import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Registration from '../pages/Registration';
import HeaderComponent from '../components/HeaderComponent';

class AppRoutes extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <HeaderComponent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Registration />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default AppRoutes;
